import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20warm%20toned%20anime%20manga%20illustration%20collage%20with%20dynamic%20action%20scenes%20and%20character%20silhouettes%20in%20orange%20red%20and%20gold%20tones%2C%20artistic%20composition%20with%20soft%20gradients%2C%20modern%20editorial%20design%2C%20reading%20atmosphere%2C%20warm%20ambient%20lighting%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
          alt="43423漫画网 - 免费漫画阅读平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="w-full max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/90 text-white rounded-full mb-5 whitespace-nowrap">
              {heroData.tagline}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-white/85 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-white whitespace-nowrap">{stat.value}</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.ctaPrimary.href}
                onClick={(e) => { e.preventDefault(); document.querySelector(heroData.ctaPrimary.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.ctaPrimary.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.ctaSecondary.href}
                onClick={(e) => { e.preventDefault(); document.querySelector(heroData.ctaSecondary.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-md border border-white/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.ctaSecondary.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[420px] aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20manga%20reading%20scene%20on%20smartphone%20screen%20displaying%20beautifully%20illustrated%20comic%20art%20in%20warm%20orange%20and%20amber%20tones%2C%20modern%20digital%20reading%20concept%2C%20clean%20minimal%20presentation%2C%20editorial%20product%20photography%20style%2C%20soft%20warm%20lighting%2C%20premium%20aesthetic&width=840&height=1120&seq=hero-manga-feature&orientation=portrait"
                alt="43423漫画网下拉式阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}